/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'auth': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512.117 0l408.886 149.173v551.854a632.504 632.504 0 01-128.258 153.638 1396.744 1396.744 0 01-274.706 166.656l-6.062 2.632-6.063-2.632a1398.765 1398.765 0 01-274.706-166.656 633.773 633.773 0 01-128.258-153.59v-551.95zm0 90.895L188.44 208.86v469.184A681.476 681.476 0 00289.533 791.97a1126.926 1126.926 0 00222.82 137.094A1124.2 1124.2 0 00735.218 791.97 676.071 676.071 0 00836.03 677.904V208.908zm-42.674 448.411a170.745 170.745 0 1185.349 0v70.827h85.96v85.443h-86.007v125.861h-85.302v-281.99zm42.674-250.595a85.349 85.349 0 1085.35 85.349 85.396 85.396 0 00-85.35-85.35z" _fill="#267FF9" opacity=".497"/>'
  }
})
